<template>
  <div
    v-if="plan"
    :class="`card ${planColor} roomy header`"
  >
    <span
      class="tag primary size-lg"
      style="--tag-padding: var(--spacing-2xs) var(--spacing-xs) var(--spacing-2xs) var(--spacing-sm)"
      >{{ planName }}</span
    >
    <div class="text-left margin-top-xl display-flex flex-column">
      <p>{{ description }}</p>
      <ul
        :class="['fa-ul', { 'margin-y-xs': allIconPacks }]"
        style="--list-item-margin-bottom: var(--spacing-sm)"
      >
        <li v-if="allIconPacks">
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faIcons" />
          </span>
          Access to ALL Icon Packs
        </li>
        <li v-if="allIconPacks">
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faShapes" />
          </span>
          New Pro+ Icon Packs
        </li>
        <li v-else>
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faIcons" />
          </span>
          Core Pro Icon Packs
        </li>
        <li>
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faGrid2Plus" />
          </span>
          {{ plan.customIcons }} Custom Icons
        </li>
        <li>
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faSuitcase" />
          </span>
          {{ plan.kits }} Kits
        </li>
        <li>
          <span class="fa-li">
            <font-awesome-icon :icon="$v7.solid.faSignalBars" />
          </span>
          {{ formatNumber(plan.monthlyPageviews) }} Pageviews
        </li>
      </ul>
      <site-link
        :to="{ name: 'plans', query: { plans: planTier } }"
        class="button flat block with-border"
        :style="`--link-color: var(--fa-navy); --border-color: var(--fa-dk-${planColor}); --button-margin-bottom: 0; margin-top: var(--spacing-sm)`"
        @click.native="$posthog.capture('upgrade_link_click', { context: 'home_view' })"
        >See All {{ planName }} Plans</site-link
      >
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import UtilsMixin from 'app/views/UtilsMixin'

  export default {
    name: 'ComparePlanCard',

    mixins: [UtilsMixin],

    props: {
      sku: {
        type: String,
        required: true
      },
      allIconPacks: {
        type: Boolean,
        default: false
      },
      planColor: {
        type: String,
        default: 'yellow'
      },
      planName: {
        type: String,
        required: true
      },
      planTier: {
        type: String,
        default: 'pro'
      },
      description: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        plan: null
      }
    },

    async created() {
      this.plan = await this.fetchPlan(this.sku)
    },

    methods: {
      ...mapActions('plans', ['fetchPlan'])
    }
  }
</script>
